import script from "./BaseMessageField.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseMessageField.vue?vue&type=script&setup=true&lang=js"

import "./BaseMessageField.vue?vue&type=style&index=0&id=437a1f86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-437a1f86"]])

export default __exports__